Object.filter = (obj, predicate) =>
  Object.keys(obj).filter(key => predicate(obj[key]))
    .reduce((res, key) => {
      res[key] = obj[key]
      return res
    }, {})

Object.forEach = (obj, callback) =>
  Object.keys(obj)
    .map(key => {
      return { key, value: obj[key] }
    })
    .forEach(callback)



// WEBPACK FOOTER //
// ./src/utils.js